module.exports = __webpack_public_path__ + "img/html-blocks.b591d97a.svg";